import type {ForwardedRef, ReactElement} from 'react';
import React from 'react';
import {TimelineHandleSide, TimelineItemHandleProps, TimelineItemHandleType} from './timeline-item-handle.types';
import styles from './timeline-item-handle.module.scss';

function TimelineItemHandle(
  {
    className = '',
    isActive = false,
    activeType = TimelineItemHandleType.Default,
    type = TimelineItemHandleType.Default,
    side = TimelineHandleSide.Left,
    ...props
  }: TimelineItemHandleProps,
  ref: ForwardedRef<HTMLDivElement>
): ReactElement<any> {
  const getClassFromType = (): string => {
    switch (isActive ? activeType : type) {
      case TimelineItemHandleType.Blue:
        return styles.blue;
      case TimelineItemHandleType.Purple:
        return styles.purple;
      case TimelineItemHandleType.Green:
        return styles.green;
      case TimelineItemHandleType.Default:
      default:
        return styles.default;
    }
  };

  return (
    <div id={props.id} ref={ref} className={`${styles.container} flex-center ${getClassFromType()} ${side === TimelineHandleSide.Left ? styles.left : styles.right}  ${className}`}>
      <div className={`${styles.innerContent} radius-round`} />
    </div>
  );
}

export default React.forwardRef(TimelineItemHandle);
